/**
 * Finds the correct price tier for a given kg and type.
 * Returns the tier object or null if no tier matches.
 */
export const findPriceTier = (pricingData, categoryName, kg, type) => {
  const tiers = pricingData?.[categoryName];
  if (!tiers || !tiers.length) return null;

  const kgNum = Number(kg);
  if (!kgNum || kgNum <= 0) return null;

  return (
    tiers.find(
      (tier) =>
        tier.status === "active" &&
        tier.type === type &&
        kgNum >= Number(tier.min_kg) &&
        kgNum <= Number(tier.max_kg)
    ) || null
  );
};

/**
 * Returns the discount_percentage for a given category, kg, and type.
 * Returns 0 if no matching tier found.
 */
export const getPricePerKg = (pricingData, categoryName, kg, type) => {
  const tier = findPriceTier(pricingData, categoryName, kg, type);
  return tier ? Number(tier.discount_percentage) : 0;
  // return tier ? Number(tier.discounted_price) : 0;
  // return tier ? Number(tier.price_per_kg) : 0;
};

/**
 * Returns the original price_per_kg (before discount) for a given category, kg, and type.
 * Returns 0 if no matching tier found.
 */
export const getOriginalPricePerKg = (pricingData, categoryName, kg, type) => {
  const tier = findPriceTier(pricingData, categoryName, kg, type);
  return tier ? Number(tier.price_per_kg) : 0;
};

/**
 * Validates that the entered kg falls within at least one active tier.
 * Returns an error message string, or null if valid.
 */
export const validateKg = (pricingData, categoryName, kg, type) => {
  const kgNum = Number(kg);

  // Empty or zero — not an error yet
  if (!kg || kgNum <= 0) return null;

  // Pricing not loaded yet — skip validation
  if (!pricingData || Object.keys(pricingData).length === 0) return null;

  const tiers = pricingData?.[categoryName]?.filter(
    (t) => t.status === "active" && t.type === type
  );

  // No tiers defined for this type — skip validation
  if (!tiers || tiers.length === 0) return null;

  const tier = tiers.find(
    (t) => kgNum >= Number(t.min_kg) && kgNum <= Number(t.max_kg)
  );

  if (!tier) {
    const ranges = tiers
      .map((t) => `${Number(t.min_kg)}kg – ${Number(t.max_kg)}kg`)
      .join(", ");
    return `Invalid weight. Accepted ranges: ${ranges}`;
  }

  return null;
};
